// ═══════════════════════════════════════════════════════════════════
//  layout/GlobalResponsiveStyles.js
//  GlobalResponsiveStyles
// ═══════════════════════════════════════════════════════════════════

import { MOBILE_BREAKPOINT } from "../socle/theme";

// Styles globaux : confort mobile (anti-zoom iOS sur les champs, pas de scroll horizontal)
export function GlobalResponsiveStyles() {
  return (
    <style>{`
      * { -webkit-tap-highlight-color: transparent; }
      html, body { margin: 0; }
      @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        body { overflow-x: hidden; }
        input, textarea, select { font-size: 16px !important; }
      }
    `}</style>
  );
}
